import lodash from "lodash";

import ObjectUtil from "../../../../react/core/utils/ObjectUtil";
import { initGlobalSharedData } from "../../../../react/core/utils/setGlobalSharedData";

const { isUndefinedOrNull } = ObjectUtil;

/**
 * This method sets the translations data object into integratedSharedData
 * @param {object} data
 * @returns {Map} a map of empowers translations service data
 * @example setGlobalTranslations(json)
 */
export const setGlobalTranslations = (data) => {
    initGlobalSharedData();

    const { integratedSharedData } = globalThis;

    if (
        !isUndefinedOrNull(integratedSharedData) &&
        !lodash.isEmpty(integratedSharedData.translations)
    ) {
        return;
    }
    if (isUndefinedOrNull(data)) {
        console.warn("No data passed to setGlobalTranslations");
        return;
    }
    const translations = new Map(Object.entries(data));
    globalThis.integratedSharedData.translations = translations;
};

/**
 * This method gets the translations data object/string from integratedSharedData
 * @param {string} label
 * @returns {object | string} an object or a string depending on json structure
 * @example selectTranslations("app")
 */
export const selectTranslations = (label) => {
    const { integratedSharedData } = globalThis;

    if (isUndefinedOrNull(label)) {
        console.warn("No label selected for selectTranslations");
        return null;
    }
    if (
        lodash.isEmpty(integratedSharedData) ||
        isUndefinedOrNull(integratedSharedData.translations) ||
        lodash.isEmpty(integratedSharedData.translations)
    ) {
        console.warn("Translations are not ready");
        return null;
    }
    return integratedSharedData.translations.get(label);
};
